import "./SiteFooter.scss"

import React from "react"
import { BrandMark } from "@fider/components"
import { useFider } from "@fider/hooks"
import { BRAND_SOCIAL, BRAND_WORDMARK } from "@fider/services/brand"
import { i18n } from "@lingui/core"

// Tùy biến KHCN: chân trang theo bản thiết kế — logo + wordmark + tagline, liên kết, mạng xã hội, khẩu hiệu.
// Liên kết pháp lý chỉ hiện khi site có cấu hình điều khoản; mạng xã hội chỉ hiện khi có URL trong brand.ts.

const SOCIAL_ICONS: { [key: string]: React.ReactNode } = {
  facebook: <path d="M14 8h2.5V5H14c-2.2 0-3.5 1.5-3.5 3.6V10H8v3h2.5v7h3v-7h2.4l.6-3h-3V8.8c0-.5.2-.8.5-.8z" />,
  youtube: (
    <path d="M4 9.2c0-1.5 1.1-2.7 2.6-2.8C8.6 6.2 10.5 6 12 6s3.4.2 5.4.4c1.5.1 2.6 1.3 2.6 2.8v5.6c0 1.5-1.1 2.7-2.6 2.8-2 .2-3.9.4-5.4.4s-3.4-.2-5.4-.4C5.1 17.5 4 16.3 4 14.8V9.2zM10.5 9.5v5l4.5-2.5-4.5-2.5z" />
  ),
  zalo: (
    <path d="M7 7h10M7 7l-1 10h12l-1-10M9.5 11.5h5l-5 4h5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  ),
}

export const SiteFooter = () => {
  const fider = useFider()
  const socials = Object.keys(BRAND_SOCIAL).filter((key) => !!BRAND_SOCIAL[key])

  return (
    <footer className="kh-footer">
      <div className="container kh-footer__inner">
        <div className="kh-footer__top">
          <a href="/" className="kh-footer__brand" aria-label={fider.session.tenant.name}>
            <BrandMark size={40} />
            <span className="kh-footer__brand-text">
              <span className="kh-footer__wordmark">{BRAND_WORDMARK}</span>
              <span className="kh-footer__tagline">{i18n._({ id: "khcn.header.tagline", message: "Ideas today – Hà Tĩnh tomorrow" })}</span>
            </span>
          </a>

          <nav className="kh-footer__links" aria-label={i18n._({ id: "header.nav.label", message: "Main navigation" })}>
            <a href="/">{i18n._({ id: "khcn.footer.forum", message: "Forum" })}</a>
            <a href="/roadmap">{i18n._({ id: "header.nav.roadmap", message: "Roadmap" })}</a>
            {fider.settings.hasLegal && (
              <>
                <a href="/terms">{i18n._({ id: "khcn.footer.terms", message: "Terms" })}</a>
                <a href="/privacy">{i18n._({ id: "khcn.footer.privacy", message: "Privacy" })}</a>
              </>
            )}
          </nav>

          {socials.length > 0 && (
            <div className="kh-footer__social">
              {socials.map((key) => (
                <a
                  key={key}
                  href={BRAND_SOCIAL[key]}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`kh-footer__social-link kh-footer__social-link--${key}`}
                  aria-label={key}
                >
                  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    {SOCIAL_ICONS[key]}
                  </svg>
                </a>
              ))}
            </div>
          )}
        </div>

        {/* Khẩu hiệu: hàng riêng, căn giữa, cỡ lớn — không nằm ở góc phải dưới nên không đụng nút "lên đầu trang" */}
        <p className="kh-footer__motto">
          <span className="kh-footer__motto-line">{i18n._({ id: "khcn.footer.motto1", message: "Create today" })}</span>
          <span className="kh-footer__motto-sep" aria-hidden="true" />
          <span className="kh-footer__motto-line kh-footer__motto-line--accent">{i18n._({ id: "khcn.footer.motto2", message: "prosper tomorrow" })}</span>
        </p>
      </div>
      <p className="kh-footer__copy">
        © {new Date().getFullYear()} {fider.session.tenant.name}
      </p>
    </footer>
  )
}
